import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, take } from 'rxjs/operators';

import { select, Store } from '@ngrx/store';
import { selectRouteState } from '@state/route';

import { ServiceRequestService } from 'src/app/services/service-request/service-request.service';
import * as ServiceRequestActions from './service-request.actions';

@Injectable()
export class ServiceRequestEffects {
  constructor(
    private store: Store,
    private actions$: Actions,
    private serviceRequestService: ServiceRequestService
  ) {}

  fetchServiceRequests$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ServiceRequestActions.fetchServiceRequests),
      switchMap(() =>
        from(this.serviceRequestService.get()).pipe(
          map((serviceRequests) =>
            ServiceRequestActions.fetchServiceRequestsSuccess({
              serviceRequests,
            })
          ),
          catchError((error) =>
            of(ServiceRequestActions.fetchServiceRequestsFailed({ error }))
          )
        )
      )
    )
  );

  fetchServiceRequestById$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ServiceRequestActions.fetchServiceRequestById),
      switchMap(({ serviceRequestId }) =>
        from(this.serviceRequestService.getById(serviceRequestId)).pipe(
          map((serviceRequest) =>
            ServiceRequestActions.fetchServiceRequestByIdSuccess({
              serviceRequest,
            })
          ),
          catchError((error) =>
            of(ServiceRequestActions.fetchServiceRequestByIdFailed({ error }))
          )
        )
      )
    )
  );

  fetchCurrentServiceRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ServiceRequestActions.fetchCurrentServiceRequest),
      mergeMap(() => this.store.pipe(select(selectRouteState), take(1))),
      switchMap((route) => {
        const serviceRequestId = route.params['serviceRequestId'];
        return of(
          ServiceRequestActions.fetchServiceRequestById({ serviceRequestId })
        );
      })
    )
  );

  recreateServiceRequest$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ServiceRequestActions.recreateServiceRequest),
      switchMap(({ serviceRequestId, data }) =>
        from(this.serviceRequestService.recreate(serviceRequestId, data)).pipe(
          map((serviceRequest) =>
            ServiceRequestActions.recreateServiceRequestSuccess({
              serviceRequest,
            })
          ),
          catchError((error) =>
            of(ServiceRequestActions.recreateServiceRequestFailed({ error }))
          )
        )
      )
    )
  );
}
